import React from 'react';

const SectionNumOfPeople = ({
  event,
  setEvent,
  capacityError,
  setPlaceError,
}) => {
  const numOfPeopleList = React.useMemo(() => {
    let num_of_people = [];
    let extra_numbers = [200,300,400,500,600,700,800,900,1000,1200,1400,1600,1800,2000,2500,3000,3500,4000,4500,5000,6000,7000,8000,9000,10000,11000,12000,13000,14000,15000,16000,17000,18000,19000,20000,21000,22000,23000,24000,25000,26000,27000,28000,29000,30000,31000,32000,33000,34000,35000,36000,37000,38000,39000,40000,45000,50000,55000,60000,65000,70000,75000,80000,85000,90000,95000,100000,200000,300000,400000,500000,600000,700000,800000,900000,1000000];
    for (let i = 2; i <= 100; i++) {
      num_of_people.push(i);
    }
    for (const extra_number of extra_numbers) {
      num_of_people.push(extra_number);
    }
    return num_of_people.map((i) => (
      <option value={i} key={i}>
        {i}
      </option>
    ));
  }, []);

  const onPlaceError = React.useCallback(() => {
    if (!event.is_online && !event.place) {
      setPlaceError('集合場所を入力してください。');
    } else {
      setPlaceError('');
    }
  }, [event]);

  return (
    <section id="num_of_people">
      <div className="container col-md-8 col-lg-6">
        <p className="text-fz-14px text-fw-bold text-black-50 mb-2_5 mt-4 d-inline-block">
          募集人数
        </p>
      </div>
      <div className="shadow-sm mb-3 bg-white">
        <div
          className={`container col-md-8 col-lg-6 ${!!capacityError ? 'bg-light-pink' : ''
            }`}
        >
          {!!capacityError && (
            <p className="text-danger text-fz-small mb-0">{capacityError}</p>
          )}
          <div className="row justify-content-between border-bottom p-3_5">
            <p className="col-4 mb-0 pt-2 pl-0">最小催行人数</p>
            <select
              id="min_num_of_people"
              onChange={(e) => {
                const min_num_of_people = Number(e.target.value);
                setEvent((prev) => ({
                  ...prev,
                  min_num_of_people,
                }));
              }}
              onClick={() => onPlaceError()}
              defaultValue={event.min_num_of_people}
              className="col-4 p-0 textarea--eventreport text-gray form-select text-right"
            >
              {numOfPeopleList}
            </select>
          </div>
          <div className="row justify-content-between p-3_5">
            <p className="col-4 mb-0 pl-0">最大人数</p>
            <select
              id="capacity"
              onChange={(e) => {
                const capacity =
                  e.target.value === '' ? null : Number(e.target.value);
                setEvent((prev) => ({
                  ...prev,
                  capacity,
                }));
              }}
              onClick={() => onPlaceError()}
              defaultValue={event.capacity || ''}
              className="col-4 p-0 textarea--eventreport text-gray form-select text-right"
            >
              <option value={''}>制限なし</option>
              {numOfPeopleList}
            </select>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SectionNumOfPeople;
